<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <div class="border rounded p-2">
                <i class="mb-3 d-block" style="font-weight: bold;"
                  >{{ name }} Updated</i
                >
                <router-link
                  :to="{
                    name: 'EditClient',
                    params: { Id: this.$route.params.Id },
                  }"
                  class="btn btn-primary mr-1"
                  >Edit {{ name }}</router-link
                >
                <router-link
                  :to="{ name: 'ManageClients' }"
                  class="btn btn-primary"
                  >Manage Clients</router-link
                >
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "ComponentName",
  data() {
    return {
      Loading: false,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  computed: {
    name() {
      return this.$store.state.manageClients.client.name;
    },
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageClients",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
